import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { VatAndPaymentRequest as VatAndPaymentType } from '../../../../business/models/dto/rim/vat-and-payment.request.dto';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './rim.module.css';
import { updateVatAndPayment, setCurrentTabAsDirty, updateRimIBAN, updateRimBBAN } from '../../../../store/details/rim/actions';
import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import { Role } from '../../../../store/shared/model';
import { BusinessValidation, BusinessValidationType } from '../../../../business/models/policy-business.model';
import { BelfiusIban } from 'src/components/custom/belfius-iban-input';

interface PropsFromState {
  readonly vatAndPayment: VatAndPaymentType;
  readonly locked: boolean;
  readonly validations: BusinessValidation[];
}

interface PropsFromDispatch {
  readonly updateValues: typeof updateVatAndPayment;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
  readonly updateRimIBAN: typeof updateRimIBAN;
  readonly updateRimBBAN: typeof updateRimBBAN;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class VatAndPayment extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  updateIban = (iban: string) => {
    this.props.updateValues({ ...this.props.vatAndPayment, iban: iban});
    this.props.updateRimIBAN();
    this.props.setCurrentTabAsDirty();
  }


  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>{this.localization.get('details.rim.vatAndPayment.info')}</span>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                <span>
                  {this.localization.formatString(
                    'details.rim.vatAndPayment.vatToBeJustified', {
                      vatPercentage: '6%'
                    })}
                </span>&nbsp;
                <BelfiusCurrencyText
                  value={this.props.vatAndPayment.vat6ToBeJustifiedAmount}
                  suffix={' EUR'} />
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                <span>{this.localization.formatString(
                  'details.rim.vatAndPayment.vatToBeJustified', {
                    vatPercentage: '21%'
                  })}
                </span>&nbsp;
                <BelfiusCurrencyText
                  value={this.props.vatAndPayment.vat21ToBeJustifiedAmount}
                  suffix={' EUR'} />
              </span>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.vatAndPayment.deductibleVatPercentage')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.vatAndPayment.deductibleVatPercentage.placeholder')}
                value={this.props.vatAndPayment.deductibleVatPercentage}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.vatAndPayment, deductibleVatPercentage: +event.target.value });
                  this.props.setCurrentTabAsDirty();
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>{this.localization.get('details.rim.vatAndPayment.payment.info')}</span>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.column}>
              <div className={`${styles.item} ${styles.border}`}>
                <RadioGroup
                  value={this.props.vatAndPayment.paidByBankTransfer != null ? this.props.vatAndPayment.paidByBankTransfer.toString() : ''}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const paidByBankTransfer = event.target.value === 'true';
                    this.setState({ ...this.state, paidByBankTransfer });
                    this.props.updateValues({ 
                      ...this.props.vatAndPayment, 
                      paidByBankTransfer 
                    });
                    this.props.setCurrentTabAsDirty();
                  }}
                  className={styles.radio}
                >
                  <FormControlLabel
                    disabled={this.props.locked}
                    value='true'
                    control={<Radio />}
                    label={this.localization.get('details.rim.vatAndPayment.byBankTransfer')} />
                  <FormControlLabel
                    disabled={this.props.locked}
                    value='false'
                    control={<Radio />}
                    label={this.localization.get('details.rim.vatAndPayment.paidByConsultant')} />
                </RadioGroup>
              </div>
              <div className={`${styles.item} ${styles.border}`}>
                <span className={styles.text}></span>
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                {this.props.vatAndPayment.paidByBankTransfer
                && this.props.validations.find(item => item.businessValidationType === BusinessValidationType.ibanRim && item.hasError === true)
                && <div className={styles.notValid} ></div> }
                  <BelfiusIban
                      className={styles.input}
                      locked={this.props.locked}
                      placeholder={this.localization.get('details.person.iban')}
                      value={this.props.vatAndPayment.iban ? this.props.vatAndPayment.iban : ''}
                      onUpdateValue={this.updateIban} />
                </div>
              </div>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                  <input className={styles.input}
                    disabled={this.props.locked}
                    placeholder={this.localization.get('details.person.bic')}
                    value={this.props.vatAndPayment.bicCode ? this.props.vatAndPayment.bicCode : ''}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      this.props.updateValues({ ...this.props.vatAndPayment, bicCode: event.target.value });
                      this.props.setCurrentTabAsDirty();
                    }} />
                </div>
              </div>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                  <input className={styles.input}
                    disabled={this.props.locked}
                    placeholder={this.localization.get('details.person.bban')}
                    value={this.props.vatAndPayment.bban ? this.props.vatAndPayment.bban : ''}
                    autoComplete='off'
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      this.props.updateValues({ ...this.props.vatAndPayment, bban: event.target.value });
                      this.props.updateRimBBAN();
                      this.props.setCurrentTabAsDirty();
                    }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

const mapStateToProps = ({ details: { detailsRim }, caseState: { selectedCase }, shared: { roles }}: ApplicationState): PropsFromState => ({
  vatAndPayment: detailsRim.vatAndPayment,
  locked: detailsRim.locked === '' ? false : detailsRim.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
  validations: detailsRim.validations
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  updateValues: (vatAndPayment: VatAndPaymentType) => dispatch(updateVatAndPayment(vatAndPayment)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty()),
  updateRimIBAN: () => dispatch(updateRimIBAN()),
  updateRimBBAN: () => dispatch(updateRimBBAN())
});

export default connect(mapStateToProps, mapDispatchToProps)(VatAndPayment);
